var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group bg-gray-800 rounded px-1 cursor-pointer",on:{"click":function($event){return _vm.$store.commit('userInterface/toggleSidebar')}}},[_c('fa-icon',{staticClass:"group-hover:text-gray-200",attrs:{"fixed-width":"","icon":"bars"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }